import React, { useEffect, useRef } from "react"
import PropTypes from 'prop-types'
import modules from './message.module.scss';
import withTheme from "../../common/hoc/withTheme";
import { styled } from "../../utilities";

const StyledMessage = styled.div`
  ${({ $color, theme = {} }) => {
      return {
        color: $color ? $color : theme.color ? theme.color : ''
    }
  }}
`;

const Message = (props = {}) => {
    const { className, gutterBottom, label, alignment, avatar, children, color, ...rest } = props

    let completeClassName = modules.messageContainer
    if (alignment === 'right') completeClassName += ` ${modules.alignRight}`
    if (gutterBottom) completeClassName += ` ${modules.gutterBottom}`
    if (className) completeClassName += ` ${className}`
    const messageProps = {
        className: completeClassName
    }

    if (avatar) {
        return <StyledMessage {...messageProps} $color={messageProps.color || color}>
            {avatar}
            <div className={modules.innerContainer}>
                <Subheading alignRight={alignment === 'right'} label={label} />
                {children}
            </div>
        </StyledMessage>
    }

    return <StyledMessage {...messageProps} className={`${modules.innerContainer} ${messageProps.className}`.trim()} $color={messageProps.color || color}>
        <Subheading alignRight={alignment === 'right'} label={label} />
        {children}
    </StyledMessage>
}

const Subheading = ({ label, alignRight }) => label 
    ? <span aria-hidden="true" className={`${modules.subheading}${alignRight ? ` ${modules.alignRight}` : ''}`}>
        {label}
    </span>
    : null

Message.defaultProps = {
    className: '',
    gutterBottom: true,
    alignment: 'left'
}

Message.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    gutterBottom: PropTypes.bool,
    alignment: PropTypes.oneOf(['left', 'right'])
}

export default withTheme(Message)